/**
 * Transform general info for display on MyAccount General page
 *
 * @param generalInfo
 * @param options
 * @return {{countryCode, firstName, language, lastName, locale, middleName, phone, prefix, suffix, timezone}}
 */
export const transformDisplayInfo = (generalInfo, options) => {
    const {
        firstName,
        language,
        lastName,
        locale,
        middleName,
        phone,
        phoneCountryCode,
        prefix,
        suffix,
        timezone,
    } = generalInfo;

    return {
        countryCode: phoneCountryCode,
        firstName,
        language: options.languages[language],
        lastName,
        locale: options.locales[locale],
        middleName,
        phone,
        prefix,
        suffix,
        timezone: (options.timezones.find((tz) => tz.value === timezone) ?? {})?.label,
    };
};

/**
 * Transform server response for consistent naming patterns in UI code
 * Data from the server response is different between GET and POST to ui/user/general
 * i.e. GET returns firstName while POST returns first_name
 *
 * @param generalInfo
 * @return {{firstName, lastName, language, locale, timezone, phone, phoneCountryCode, middleName, prefix, suffix}}
 */
export const transformGeneralInfo = (generalInfo = {}) => {
    const {
        // eslint-disable-next-line camelcase
        first_name,
        language,
        // eslint-disable-next-line camelcase
        last_name,
        locale,
        // eslint-disable-next-line camelcase
        middle_name,
        // eslint-disable-next-line camelcase
        phone_country_code,
        // eslint-disable-next-line camelcase
        phone_number,
        prefix,
        suffix,
        timezone,
    } = generalInfo;
    return {
        firstName: first_name,
        lastName: last_name,
        language,
        locale,
        timezone,
        phone: phone_number,
        phoneCountryCode: phone_country_code,
        middleName: middle_name,
        prefix,
        suffix,
    };
};
